var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnBanned(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M.056.647h19.43v19.43H.056z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M0 .647h14.009v11.6H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#949494",
    d: "M10.83 10.753A4.655 4.655 0 0 1 6.18 6.1a4.655 4.655 0 0 1 4.651-4.65c2.554 0 4.64 2.085 4.64 4.65 0 2.566-2.086 4.652-4.64 4.652M10.83 0a6.103 6.103 0 0 0-6.101 6.101 6.103 6.103 0 0 0 6.101 6.102c3.357 0 6.09-2.733 6.09-6.102 0-3.368-2.733-6.1-6.09-6.1"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.038 8.856)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#949494",
    d: "M9.77 18.627a8.258 8.258 0 0 1-6.39-3.035 8.332 8.332 0 0 1-.96-1.45 8.292 8.292 0 0 1-.914-3.78c0-1.717.535-3.325 1.45-4.65.29-.447.636-.86 1.015-1.239a8.244 8.244 0 0 1 5.8-2.376 8.268 8.268 0 0 1 8.265 8.265c0 4.551-3.703 8.265-8.265 8.265m0-17.98a9.72 9.72 0 0 0-7.429 3.457h-.01c-.347.425-.67.882-.949 1.373a9.57 9.57 0 0 0-1.327 4.885c0 1.339.279 2.61.77 3.78.211.503.468.994.769 1.45 1.729 2.7 4.74 4.485 8.176 4.485 5.354 0 9.715-4.36 9.715-9.715 0-5.354-4.361-9.715-9.715-9.715",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 12.202)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#949494",
    d: "M1.74 10.797a.29.29 0 0 1-.212-.09.323.323 0 0 1-.078-.234 9.423 9.423 0 0 1 9.38-8.376c.2 0 .39.01.591.033.536.022 1.06.1 1.573.234.29-.446.636-.859 1.015-1.238a9.858 9.858 0 0 0-1.628-.368h-.012A10.872 10.872 0 0 0 .011 10.317c-.056.492.1.982.435 1.35.335.368.803.58 1.294.58h11.678a8.374 8.374 0 0 1-.96-1.45H1.74z",
    mask: "url(#d)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#949494",
    d: "M22.505 22.977l-6.451-6.45a.75.75 0 0 1 1.06-1.06l6.45 6.45a.75.75 0 0 1-1.06 1.06"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#949494",
    d: "M23.565 16.527l-6.451 6.45a.75.75 0 0 1-1.06-1.06l6.451-6.45a.75.75 0 0 1 1.06 1.06"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnBanned);
export default __webpack_public_path__ + "static/media/un_banned.68d813ae2169a0a3711b4c6041fcd387.svg";
export { ForwardRef as ReactComponent };